import React from "react";

/**
 * Render free-form text with clickable URLs while keeping the rest of
 * the text selectable/copyable (the browser already allows selection
 * on plain text — we only need to render URL chunks as `<a>` tags and
 * keep the surrounding text as plain text so the user can highlight
 * either portion).
 */
const URL_RE = /((?:https?:\/\/|www\.)[^\s<]+?)(?=[\s.,;!?)\]]*(?:\s|$))/gi;

export default function LinkifyText({ text, className, style, ...rest }) {
  if (!text) return null;
  const parts = [];
  let last = 0;
  for (const m of text.matchAll(URL_RE)) {
    const idx = m.index ?? 0;
    if (idx > last) parts.push({ kind: "text", value: text.slice(last, idx) });
    parts.push({ kind: "url", value: m[1] });
    last = idx + m[1].length;
  }
  if (last < text.length) parts.push({ kind: "text", value: text.slice(last) });

  return (
    <span className={className} style={style} {...rest}>
      {parts.map((p, i) =>
        p.kind === "url" ? (
          <a
            key={i}
            href={p.value.startsWith("http") ? p.value : `https://${p.value}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#c9a84c", textDecoration: "underline", wordBreak: "break-all" }}
            onClick={(e) => e.stopPropagation()}
          >
            {p.value}
          </a>
        ) : (
          <React.Fragment key={i}>{p.value}</React.Fragment>
        ),
      )}
    </span>
  );
}
